<p>auth-forgot-password works!</p>
